export default __webpack_public_path__ + "static/media/background-heavy.8dc9bef7.jpg";